import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { PropTypes } from 'prop-types';
import { Link } from "react-router-dom";
import { Collapse } from 'reactstrap';
import * as Tools from "../../helpers/Tools";

const AppointmentOverview = ({ recipientsPhase, locationPhase, vaccinesPhase, eligibilityPhase, datePhase,
    confirmPhase, selectedUsers, serviceLocation, selectedVaccines, selectedDateTime, cities }) => {

    const [toggleContent, settoggleContent] = useState(false);
    const sectionActive = (section) => {
        switch (section) {
            case 'recipients':
                return true
            case 'location':
                if (locationPhase || vaccinesPhase || eligibilityPhase || datePhase || confirmPhase) {
                    return true
                }
                return false;
            case 'vaccines':
                if (vaccinesPhase || eligibilityPhase || datePhase || confirmPhase) {
                    return true
                }
                return false;
            case 'eligibility':
                if (eligibilityPhase || datePhase || confirmPhase) {
                    return true
                }
                return false;
            case 'date':
                if (datePhase || confirmPhase) {
                    return true
                }
                return false;
            case 'confirmDetail':
                if (confirmPhase) {
                    return true;
                }
                return false
            default:
                return false
        }
    }

    const formatCity = (cityName) => {
        if (cityName && cities) {
            let formattedCity = cities.find(c => c.value === cityName.toLowerCase())
            if (formattedCity) return formattedCity.label;
        }
        return cityName;
    }

    const getSelectedVaccines = () => {
        const allSelectedVaccines = {};

        selectedVaccines.forEach(item => {
            item.vaccines.forEach(vax => {
                if (vax.isChecked) {
                    let user = selectedUsers.find(user => user.mrn === item.mrn)
                    if (allSelectedVaccines[vax.displayName] === undefined) {
                        allSelectedVaccines[vax.displayName] = { count: 1, users: [user.firstName] };
                    }
                    else {
                        allSelectedVaccines[vax.displayName].count = allSelectedVaccines[vax.displayName].count + 1;
                        allSelectedVaccines[vax.displayName].users.push(user.firstName);
                    }
                }
            })
        });
        return allSelectedVaccines;
    }

    const displaySelectedVaccines = () => {
        const arr = getSelectedVaccines();
        return Object.keys(arr).map((key) => (
            <div key={`vaccines-${key}`}>
                <span>{arr[key].count}x {key} ({arr[key].users.join(", ")})</span>
            </div>
        ))
    }

    const displayApptDateTime = () => {
        const out = { date: '', day: '', monthName: '', year: '', time: '' };
        const selected = new Date(selectedDateTime);
        let weekday = new Array(7);
        weekday[0] = "Sunday";
        weekday[1] = "Monday";
        weekday[2] = "Tuesday";
        weekday[3] = "Wednesday";
        weekday[4] = "Thursday";
        weekday[5] = "Friday";
        weekday[6] = "Saturday";
        out.day = weekday[selected.getDay()];
        out.date = selected.getDate();
        out.year = selected.getFullYear();
        out.time = Tools.timeformat(selected)
        out.monthName = selected.toLocaleString('default', { month: 'long' });
        return (
            <>
                <span>{out.day}, {out.monthName} {out.date}, {out.year}</span><br />
                <span>{out.time}</span>
            </>
        )
    }

    const appointmentSection = () => {
        return (
            <>
                <div className="info-wrapper">
                    <div>
                        {
                            sectionActive('location') ?
                                <Link to='/inhomeschedule/s1' className="link-text" replace>
                                    <span className={sectionActive('location') ? 'title completed' : sectionActive('recipients') ? 'title active' : 'title'}>Recipients</span>
                                </Link> :
                                <span className={sectionActive('location') ? 'title completed' : sectionActive('recipients') ? 'title active' : 'title'}>Recipients</span>
                        }

                        {sectionActive('location') && !sectionActive('eligibility') && <div className="sub-details-wrapper">{selectedUsers && selectedUsers.map((u) => { return <div key={u.mrn}><span>{u.patientName} ({u.dob})</span></div> })}</div>}

                        {/*if past vaccine selection screen, filter out selected users with no selected vaccines*/}
                        {sectionActive('eligibility') && <div className="sub-details-wrapper">
                            {selectedVaccines && selectedVaccines.reduce((acc, u) => {
                                if (u.vaccines.find((v => v.isChecked))) {
                                    acc.push(
                                        <div key={u.mrn}><span>{u.patientName} ({u.dob})</span></div>
                                    )
                                }
                                return acc;
                            }, [])}</div>}
                    </div>
                    {sectionActive('location') && <div className="tickmark-wrapper"><div className="tickmark"></div></div>}
                </div>
                <div className="info-wrapper">
                    <div>
                        {
                            sectionActive('vaccines') ?
                                <Link to='/inhomeschedule/s3' className="link-text" replace>
                                    <span className={sectionActive('vaccines') ? 'title completed' : sectionActive('location') ? 'title active' : 'title'}>Location & Contact</span>
                                </Link> :
                                <span className={sectionActive('vaccines') ? 'title completed' : sectionActive('location') ? 'title active' : 'title'}>Location & Contact</span>
                        }

                        {sectionActive('vaccines') && <div className="sub-details-wrapper">
                            <span>{serviceLocation?.address1}{serviceLocation?.address2 ? `, ${serviceLocation.address2}` : ''}</span><br />
                            <span>{formatCity(serviceLocation?.city)}, {serviceLocation?.state}, {serviceLocation?.zipCode}</span><br />
                            <span>{serviceLocation?.email}</span><br />
                            <span>{serviceLocation?.mobilePhone}</span>
                        </div>}
                    </div>
                    {sectionActive('vaccines') && <div className="tickmark-wrapper"><div className="tickmark"></div></div>}
                </div>
                <div className="info-wrapper">
                    <div>
                        {
                            sectionActive('eligibility') ?
                                <Link to='/inhomeschedule/s4' className="link-text" replace>
                                    <span className={sectionActive('eligibility') ? 'title completed' : sectionActive('vaccines') ? 'title active' : 'title'}>Vaccines</span>
                                </Link> :
                                <span className={sectionActive('eligibility') ? 'title completed' : sectionActive('vaccines') ? 'title active' : 'title'}>Vaccines</span>
                        }

                        {sectionActive('eligibility') && <div className="sub-details-wrapper">
                            {displaySelectedVaccines()}
                        </div>
                        }
                    </div>
                    {sectionActive('eligibility') && <div className="tickmark-wrapper"><div className="tickmark"></div></div>}
                </div>
                <div className="info-wrapper">
                    <div>
                        {
                            sectionActive('date') ?
                                <Link to='/inhomeschedule/s5' className="link-text" replace>
                                    <span className={sectionActive('date') ? 'title completed' : sectionActive('eligibility') ? 'title active' : 'title'}>Eligibility</span>
                                </Link> :
                                <span className={sectionActive('date') ? 'title completed' : sectionActive('eligibility') ? 'title active' : 'title'}>Eligibility</span>
                        }

                    </div>
                    {sectionActive('date') && <div className="tickmark-wrapper"><div className="tickmark"></div></div>}
                </div>
                <div className="info-wrapper">
                    <div>
                        {
                            sectionActive('confirmDetail') ?
                                <Link to='/inhomeschedule/s6' className="link-text" replace>
                                    <span className={sectionActive('confirmDetail') ? 'title completed' : sectionActive('date') ? 'title active' : 'title'}>Date & Time</span>
                                </Link> :
                                <span className={sectionActive('confirmDetail') ? 'title completed' : sectionActive('date') ? 'title active' : 'title'}>Date & Time</span>
                        }

                        {sectionActive('confirmDetail') && <div className="sub-details-wrapper">
                            {displayApptDateTime()}
                        </div>
                        }
                    </div>
                    {sectionActive('confirmDetail') && <div className="tickmark-wrapper"><div className="tickmark"></div></div>}
                </div>
            </>
        )
    }
    let mobileborderWidth = '0%';
    if (recipientsPhase) {
        mobileborderWidth = '16.5%';
    } else if (locationPhase) {
        mobileborderWidth = '33%';
    } else if (vaccinesPhase) {
        mobileborderWidth = '49.5%';
    } else if (eligibilityPhase) {
        mobileborderWidth = '66%';
    } else if (datePhase) {
        mobileborderWidth = '82.5%';
    }

    return <div className={toggleContent ? 'appointment-overview-container appointment-overview-container-expand' : 'appointment-overview-container'}>
        <div className="show-mobile-only mobile-border-section-grey"></div>
        <div className="show-mobile-only mobile-border-section" style={{ width: mobileborderWidth }}></div>
        <div className="text-container">
            { /*Desktop only*/}
            <div className="heading-wrapper show-desktop-only">
                <h1 className="heading">Appointment Overview</h1>

            </div>
            <div className="show-desktop-only">
                {appointmentSection()}
            </div>
            { /*mobile and tablet only*/}
            <div className="heading-wrapper show-mobile-only" onClick={() => settoggleContent(!toggleContent)}>
                {recipientsPhase && <span className="heading">Recipients</span>}
                {locationPhase && <span className="heading">Location & Contact</span>}
                {vaccinesPhase && <span className="heading">Vaccines</span>}
                {eligibilityPhase && <span className="heading">Eligibility</span>}
                {datePhase && <span className="heading">Date & Time</span>}
                {confirmPhase && <span className="heading">Confirm</span>}
                {toggleContent ? <span className="float-right icon-dd-up heading-arrow" /> : <span className="float-right icon-dd heading-arrow" />}
            </div>
            <div>
                <Collapse isOpen={toggleContent}>
                    {appointmentSection()}
                </Collapse>
            </div>
        </div>
    </div>
}

AppointmentOverview.defaultProps = {
    recipientsPhase: false,
    locationPhase: false,
    vaccinesPhase: false,
    eligibilityPhase: false,
    datePhase: false

}

AppointmentOverview.propTypes = {
    recipientsPhase: PropTypes.bool,
    locationPhase: PropTypes.bool,
    vaccinesPhase: PropTypes.bool,
    eligibilityPhase: PropTypes.bool,
    datePhase: PropTypes.bool,
}

const mapStateToProps = state => {
    return {
        profileList: state.memberships.profileList,
        selectedUsers: state.inHome.selectedUsers || [],
        serviceLocation: state.inHome.serviceLocationContactInfo,
        selectedVaccines: state.inHome.selectedVaccines || [],
        selectedDateTime: state.inHome.selectedDateTime,
        cities: state.inHome.prefilledCities
    }
}

export default connect(mapStateToProps, null)(AppointmentOverview);